import { render } from "./BurmanNews.vue?vue&type=template&id=b0430214"
import script from "./BurmanNews.vue?vue&type=script&lang=ts"
export * from "./BurmanNews.vue?vue&type=script&lang=ts"
script.render = render

export default script